"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsxs, jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import { SvgIcon } from '../components/SvgIcon/index.mjs';
import { SvgIconType } from '../components/SvgIcon/svg-icon-type.mjs';
import { forwardRef } from 'react';
import { Root, Control, Thumb, Label } from './styled/switch.mjs';
import { SwitchHiddenInput } from '@ark-ui/react/switch';

const Switch = forwardRef((props, ref) => {
  const { children, ...rootProps } = props;
  const { checked, loading } = props;
  return /* @__PURE__ */ jsxs(Root, { ref, ...rootProps, children: [
    /* @__PURE__ */ jsx(Control, { children: loading ? /* @__PURE__ */ jsx(SvgIcon, { type: SvgIconType.Loader, className: clsx("w-4 h-4 p-0.5", checked ? "text-white" : "text-black") }) : /* @__PURE__ */ jsx(Thumb, {}) }),
    children && /* @__PURE__ */ jsx(Label, { className: "text-sm leading-5 font-normal whitespace-nowrap", children }),
    /* @__PURE__ */ jsx(SwitchHiddenInput, {})
  ] });
});
Switch.displayName = "Switch";

export { Switch };
